// package: common
// file: common/app.proto

import * as common_enum_value_options from "../common/enum_value_options";


export const App = {
    APP_UNDEFINED: 0,
    APP_SHIHUIMIAO: 1,
    APP_SHIHUIMIAO_WECHAT_H5: 2,
    APP_SHIHUIMIAO_STREAMER: 3,
    APP_SHIHUIMIAO_TOUTIAO_H5: 4,
    APP_SHIHUIMIAO_CMS: 5,
    APP_SHIHUIMIAO_CMS_STREAMER: 6,
    APP_SHIHUIMIAO_LIVE_WECHAT_MINIPROGRAM: 7,
    APP_QUTOUTIAO: 8,
    APP_QUJIANPAN: 9,
    APP_66SHIPIN: 10,
    APP_MIDU: 11,
    APP_MIAOQIANGUAN: 12,
    APP_QUQIANGHONGBAO: 13,
    APP_QUJIANPAN_SPEED: 14,
    APP_XIANWAN: 15,
    APP_SHIHUIMIAO_PHONE_BILL_MINIPROGRAM: 16,
    APP_MIAOTEHUI: 17,
    APP_MIAOFULI: 18,
    APP_MIAOYOUHUI: 19,
    APP_MIAOXIAOBAO: 20,
    APP_PREPARE_01: 1001,
    APP_PREPARE_02: 1002,
    APP_PREPARE_03: 1003,
    APP_PREPARE_04: 1004,
    APP_PREPARE_05: 1005,
    APP_PREPARE_06: 1006,
    APP_PREPARE_07: 1007,
    APP_PREPARE_08: 1008,
    APP_PREPARE_09: 1009,
    APP_PREPARE_10: 1010,
};

export const AppDisplayName = {
    0 /* APP_UNDEFINED */: "未定义",
    1 /* APP_SHIHUIMIAO */: "实惠喵APP",
    2 /* APP_SHIHUIMIAO_WECHAT_H5 */: "实惠喵微信H5",
    3 /* APP_SHIHUIMIAO_STREAMER */: "实惠喵主播端",
    4 /* APP_SHIHUIMIAO_TOUTIAO_H5 */: "实惠喵头条H5",
    5 /* APP_SHIHUIMIAO_CMS */: "实惠喵内部CMS",
    6 /* APP_SHIHUIMIAO_CMS_STREAMER */: "实惠喵主播CMS",
    7 /* APP_SHIHUIMIAO_LIVE_WECHAT_MINIPROGRAM */: "实惠喵直播微信小程序",
    8 /* APP_QUTOUTIAO */: "趣头条APP",
    9 /* APP_QUJIANPAN */: "趣键盘APP",
    10 /* APP_66SHIPIN */: "66视频APP",
    11 /* APP_MIDU */: "米读APP",
    12 /* APP_MIAOQIANGUAN */: "喵钱罐APP",
    13 /* APP_QUQIANGHONGBAO */: "趣抢红包APP",
    14 /* APP_QUJIANPAN_SPEED */: "趣键盘极速版APP",
    15 /* APP_XIANWAN */: "闲玩APP",
    16 /* APP_SHIHUIMIAO_PHONE_BILL_MINIPROGRAM */: "实惠喵话费小程序",
    17 /* APP_MIAOTEHUI */: "喵特惠APP",
    18 /* APP_MIAOFULI */: "喵福利APP",
    19 /* APP_MIAOYOUHUI */: "喵优惠APP",
    20 /* APP_MIAOXIAOBAO */: "喵小报APP",
    1001 /* APP_PREPARE_01 */: "备用app1",
    1002 /* APP_PREPARE_02 */: "备用app2",
    1003 /* APP_PREPARE_03 */: "备用app3",
    1004 /* APP_PREPARE_04 */: "备用app4",
    1005 /* APP_PREPARE_05 */: "备用app5",
    1006 /* APP_PREPARE_06 */: "备用app6",
    1007 /* APP_PREPARE_07 */: "备用app7",
    1008 /* APP_PREPARE_08 */: "备用app8",
    1009 /* APP_PREPARE_09 */: "备用app9",
    1010 /* APP_PREPARE_10 */: "备用app10",
};

